import React from 'react';
import PropTypes from 'prop-types';
import { line } from 'd3-shape';

import { surfaceType } from '@strava/constants';
import { color } from '@strava/ui-tokens/js';

import styles from './SurfaceTypePath.module.scss';

const SurfaceTypePath = ({ stream, xScale, yScale, clipPath }) => {
  const bgLineData = stream.convertedElevation.map((elev, index) => ({
    x: stream.convertedDistance[index],
    y: elev
  }));

  const draw = line()
    .x((d) => xScale(d.x))
    .y((d) => yScale(d.y));

  let tmpIdx = 0;
  const surfacesData = stream.surface.reduce((acc, val, idx, arr) => {
    const next = arr[idx + 1];

    if (!acc[tmpIdx]) {
      acc[tmpIdx] = {
        type: val,
        data: []
      };
    }

    acc[tmpIdx].data.push({
      x: stream.convertedDistance[idx],
      y: stream.convertedElevation[idx]
    });

    if (val !== next) {
      tmpIdx += 1;
    }

    return acc;
  }, []);

  return (
    <g className={styles.surfaceType} clipPath={clipPath}>
      <path
        fill="none"
        stroke={color.colorCoreO3}
        strokeWidth={4}
        d={draw(bgLineData)}
      />

      {surfacesData.map((surface, index) => {
        if ([surfaceType.PAVED, 'Paved'].includes(surface.type)) {
          return (
            <path
              key={`${surface.type}-${index.toString()}`}
              fill="none"
              stroke={color.colorCoreO3}
              strokeWidth={2}
              d={draw(surface.data)}
            />
          );
        }
        if ([surfaceType.UNPAVED, 'Unpaved'].includes(surface.type)) {
          return (
            <path
              key={`${surface.type}-${index.toString()}`}
              fill="none"
              stroke={color.colorCoreWhite}
              strokeWidth={2}
              strokeDasharray={[2, 2.5]}
              d={draw(surface.data)}
            />
          );
        }

        return (
          <path
            key={`${surface.type}-${index.toString()}`}
            fill="none"
            stroke={color.colorCoreWhite}
            strokeWidth={2}
            d={draw(surface.data)}
          />
        );
      })}
    </g>
  );
};

SurfaceTypePath.propTypes = {
  xScale: PropTypes.func.isRequired,
  yScale: PropTypes.func.isRequired,
  stream: PropTypes.shape().isRequired,
  clipPath: PropTypes.string
};

SurfaceTypePath.defaultProps = {
  clipPath: null
};

export default React.memo(SurfaceTypePath);
